import React from 'react';
import { useClientSelector } from '../redux/hooks';

export const HomePage = () => {
  const authUser = useClientSelector(state => state.firebase.authUser);

  return !authUser ? (
    <div>Must be signed in to see this page. Redirecting...</div>
  ) : null;
};
